import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=6eb6fe56&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=6eb6fe56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb6fe56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eb6fe56')) {
      api.createRecord('6eb6fe56', component.options)
    } else {
      api.reload('6eb6fe56', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=6eb6fe56&scoped=true&", function () {
      api.rerender('6eb6fe56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Z1ziZpc0DrW/JS/comp/GuestBox.vue"
export default component.exports